export default {
   'floorplanGuide': 'Sand Table',
   'floorplanGuideTips': 'Find exhibitors’ virtual booth by one click',
   'liveStream': 'Exhibitor Live Streams',
   'featuredExhibitors': 'Featured Exhibitors',
   'bookingNow': 'Enter',
   'distanceFromLiveTime': {
      'time': 'Start time',
      'noStart': 'Started'
   },
   'viewProductLive': 'View More Exhibits',
   'viewMoreLive': 'More Live Videos',
   'exhTips': 'Quick quotations from multiple suppliers',
   'youMayLike': 'You May Like',
   'concurrentEvents': 'Programmes',
   'footerTitle1': 'Beijing International High-tech Exop Online Exhibition 2020',
   'footerTitle2': 'Quick Access:',
   'footerTitle3': 'The Organizer:',
   'footerTitle4': 'April 19-22，2022',
   'footerTitle5':'Welcome',
   'footerTitle6':'To Social Media',

   'footerQuickAccess1': 'Online exhibition hall',
   'footerQuickAccess2': 'About Jinhan',
   'footerQuickAccess3': 'How to arrive',
   'footerQuickAccess4': 'Download Center',
   'footerQuickAccess5': 'Privacy Protection',
   'footerQuickAccess6': 'Site Map',
   'newText1': '3D Floor Plan',
   'newText2': 'News Center',
   'newText3': 'About Beijing International High-tech Exop',
   'newText4': 'Quick Contact',
   'newText5': 'IPR Protection',
   'newText6': 'APP Manual',
   'newText7':'Website Manual',
   'footerComName': 'Guangzhou Poly Jinhan Exhibition Co., Ltd.',
   'footerFax': 'Fax : (86-595)-85674572',
   'footerTel': 'Tel : (86-595)-85600609',
   'footerEmail': 'E-mail(MSN) : jif@cn-jif.com',
   'footerAddress': 'Address :  7F, The Disabled Service Center Building, West Side of Meiling Road, Jinjiang ,Fujian, China',
   'footerAddressTips': '(Opposite Area B, Area C, Canton Fair)',
   'footerSocialMedia': 'Social Media',
   'exhibitor': 'Exhibitors',
   'person': 'Guest',
   'Home': 'Home',
   'Exhibitor': 'Exhibitors',
   'Products': 'Products',
   'Visitor': 'Guest',
   'Business': 'Biz Hub',
   'Live': 'Live',
   'About': 'About',
   'QA':'Q&A',

   'download': 'WeChat',
   'searchPlaceHolder': 'Search',
   '晋江贸促会': 'CCPIT',
   '国际商会': '(JICC)',
   '公众号': 'WeChat',
   "purchaseMeeting": "Purchase Meeting",

   '主办单位': "主办单位:",
   '中华人民共和国科学技术部': "中华人民共和国科学技术部",
   '中华人民共和国国家知识产权局': "中华人民共和国国家知识产权局",
   '中国国际贸易促进委员会': "中国国际贸易促进委员会",
   '北京市人民政府': "北京市人民政府"   


}